import { Component, Input, OnInit } from '@angular/core'
import { HttpErrorResponse } from '@angular/common/http'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { DataCardService } from '../../../../../services/data-card.service'
import { IDataCardNotification, IDataCardWorkOrder } from '../../../../../models/data-card.model'
import { HttpResponseHandlerService } from '../../../../../services/http-response-handler.service'

@Component({
  selector: 'app-cmms-item-modal',
  templateUrl: './cmms-item-modal.component.html',
  styleUrl: './cmms-item-modal.component.scss',
  standalone: false,
})
export class CmmsItemModalComponent implements OnInit {
  @Input({ required: true }) type: 'WO' | 'WOP' | 'NO' = 'NO'
  @Input({required: true}) item: { name: string; title: string; url: string; status?: number }
  @Input() incidentDate: string = null

  private _noData: IDataCardNotification
  private _woData: IDataCardWorkOrder
  private _isLoading: boolean = false

  public get noData(): IDataCardNotification {
    return this._noData
  }

  public get woData(): IDataCardWorkOrder {
    return this._woData
  }

  public get isLoading(): any {
    return this._isLoading
  }

  constructor(
    private activeModal: NgbActiveModal,
    private dataCardService: DataCardService,
    private responseHandlerService: HttpResponseHandlerService,
  ) {}

  public cancel(): void {
    this.activeModal.dismiss({})
  }

  public getTitle(): string {
    switch (this.type) {
      case 'WOP':
        return 'Work Permit & Work Order'
      case 'WO':
        return 'Work Order'
      default:
        return 'Notification'
    }
  }

  private getWorkOrderData(): void {
    this._isLoading = true
    this.dataCardService.getWorkOrderData(this.item.name, this.incidentDate).subscribe({
      next: (resource: IDataCardWorkOrder): void => {
        this._woData = resource
        this._isLoading = false
      },
      error: (error: HttpErrorResponse): void => {
        this.responseHandlerService.notifyError(error)
        this._isLoading = false
      },
    })
  }

  private getNotificationData(): void {
    this._isLoading = true
    this.dataCardService.getNotificationData(this.item.name).subscribe({
      next: (resource: IDataCardNotification): void => {
        this._noData = resource
        this._isLoading = false
      },
      error: (error: HttpErrorResponse): void => {
        this.responseHandlerService.notifyError(error)
        this._isLoading = false
      },
    })
  }

  public ngOnInit(): void {
    if (this.type === 'WO' || this.type === 'WOP') {
      this.getWorkOrderData()
    } else if (this.type === 'NO') {
      this.getNotificationData()
    }
  }
}
